import React, { useEffect, useState } from "react";
import { SET_LOADING } from "../../redux/user";
import { useDispatch } from "react-redux";
import { api_paths } from "../../config/api.paths";
import { toastErrorMessage } from "../../utils/utils";
import API from "../../config/axios";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const ByLaws = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const dispatch = useDispatch();

  const getPageDetails = async (identifier) => {
    setIsLoading(true);
    setLoadError("");
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(`${api_paths.GET_CMS_PAGE}${identifier}`);
      if (response?.data?.payload?.result?.file_path) {
        const fileUrl = `${IMAGE_BASEURL}${response.data.payload.result.file_path}`;
        window.location.replace(fileUrl);
      } else {
        setLoadError("No bylaws document available.");
        setIsLoading(false);
        dispatch(SET_LOADING(false));
      }
    } catch (error) {
      console.log(error);
      const message =
        error?.response?.data?.message || "Failed to load bylaws.";
      setLoadError(message);
      toastErrorMessage(message);
      setIsLoading(false);
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    getPageDetails("BYLAW"); // BYLAW term_condition about_us
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid px-0">
      {isLoading && <div className="text-center py-5">Loading bylaws...</div>}

      {!isLoading && loadError && (
        <div className="text-center py-5 text-danger">{loadError}</div>
      )}
    </div>
  );
};

export default ByLaws;
